import { useSyncExternalStore } from 'react';
import { DEFAULT_GEN_MODEL, GEN_MODELS } from './models';

// Which image-generation model Phase 2 uses. A browser preference (like the
// description template), not a fact about any manual, so it lives in localStorage and
// is shared by every document this browser opens. Validated against the known models
// on read, so a stale/unknown stored id falls back to the default rather than being
// sent to the server (which would reject it).
const KEY = 'notice.genModel';
const isKnown = (id: string) => GEN_MODELS.some((m) => m.id === id);

function read(): string {
  try {
    const v = localStorage.getItem(KEY);
    return v && isKnown(v) ? v : DEFAULT_GEN_MODEL;
  } catch {
    return DEFAULT_GEN_MODEL;
  }
}

let value = read();
const listeners = new Set<() => void>();

export function setGenModel(id: string) {
  if (!isKnown(id) || id === value) return;
  value = id;
  try {
    localStorage.setItem(KEY, id);
  } catch {
    // ignore (e.g. private mode); the in-memory choice still holds for this session
  }
  listeners.forEach((notify) => notify());
}

export function useGenModel(): string {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => value,
  );
}
